import {isScdPropertyName} from 'common/report/util/properties';
import {PropertyDefinition} from 'common/util/definitions-types';
import {PropertyType, ResourceType, SCD_PROFILE_PROPERTY_PREFIX} from 'common/report/constants';

export const isMatchingProperty = (property: PropertyDefinition, dataGroupCompanyKey: string, dataGroupId: string) => {
  return (
    property.name.replace(SCD_PROFILE_PROPERTY_PREFIX, ``) === dataGroupCompanyKey &&
    property.dataGroupId === dataGroupId
  );
};

export const formatProperty = (property: {
  name: string;
  label?: string;
  type?: PropertyType;
  resourceType?: ResourceType;
  dataGroupId?: string;
  propertyDefaultType?: PropertyType;
  scdEvent?: string;
}) => {
  if (isScdPropertyName(property.name)) {
    return {
      dataGroupId: property.dataGroupId,
      label: property.label,
      propertyDefaultType: property.propertyDefaultType,
      resourceType: property.resourceType,
      scdEvent: property.scdEvent,
      type: property.type,
      value: property.name,
    };
  } else {
    return {value: property.name, resourceType: property.resourceType, dataGroupId: property.dataGroupId};
  }
};

export const preferScdProperty = (selectedProperty: {name: string}, currentProperty?: {name: string}) => {
  if (!selectedProperty || isScdPropertyName(currentProperty?.name)) {
    return currentProperty;
  }
  return selectedProperty;
};
